import React, { useState, Fragment, useContext, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import Main from "../../layout/Main";
// import { ExclamationIcon } from "@heroicons/react/outline";
import AuthContext from "../../store/authContext";
import { ExclamationIcon } from "@heroicons/react/outline";
import { Dialog, Transition } from "@headlessui/react";
import UserContext from "../../store/userContext";
import ReactLoading from "react-loading";
import mfaApi from "../../api/mfaApi";
import swal from "sweetalert";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { Dialog, Transition } from "@headlessui/react";
const EnrolledStudents = () => {
  const authCtx = useContext(AuthContext);
  const userCtx = useContext(UserContext);
  const [id, setid] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pinocde, setPincode] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [universityLink, setUniversityLink] = useState("");
  const [notifydata, setNotifydata] = useState([]);
  console.log(notifydata);

  const [added, setadded] = useState(false);

  const [isLoading, setisLoading] = useState(false);
  const [isLoadingdelete, setisLoadingdelete] = useState(false);
  const [searchvalue, setSearchvalue] = useState("");
  console.log(searchvalue);
  const [issearchLoading, setIssearchLoading] = useState(false);
  const [error, setError] = useState("");
  const [errorpin, setErrorpin] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value;

    // Allow only digits and ensure the input does not exceed 10 digits
    if (/^\d*$/.test(value) && value.length <= 10) {
      setPhone(value);

      // Clear the error if input is valid
      if (value.length === 10) {
        setError("");
      } else {
        setError("");
      }
    } else if (value.length > 10) {
      setError("Phone number cannot exceed 10 digits");
    }
  };

  const handlePincode = (e) => {
    const value = e.target.value;

    // Allow only digits and ensure the input does not exceed 10 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      setPincode(value);

      // Clear the error if input is valid
      if (value.length === 6) {
        setErrorpin("");
      } else {
        setErrorpin("");
      }
    } else if (value.length > 6) {
      setErrorpin("Pincode cannot exceed 6 digits");
    }
  };
  useEffect(() => {
    getEnquiry();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [added]);

  const EnrolledStudents = async (e) => {
    e.preventDefault();
    if (name === "" && phone === "") {
      swal("please enter all column values (non-empty values).");
    } else {
      setisLoading(true);
      try {
        const response = await mfaApi.post(
          `/nepaladmin/nepal/EnrolledStudents`,
          {
            univeristyname: name,
            href: universityLink,
            email: email,
            phone: phone,
            description: ".",
            address: address,
            pincode: pinocde,
            addedby: userCtx.userName,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authCtx.token}`,
            },
          }
        );
        if (response.status === 201) {
          setisLoading(false);
          swal(response.data.message);
          await window.location.reload();
        }
      } catch (error) {
        swal(error.response.data.message);
        setisLoading(false);
      }
      setisLoading(false);
    }
  };

  const getEnquiry = async () => {
    try {
      const response = await mfaApi.get(`/administrator/enrolleduserdetails`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authCtx.token}`,
        },
      });
      if (response.status === 200) {
        setNotifydata(response.data.getAllEnrolledUser);
        console.log(response.data.getAllEnrolledUser);
      }
    } catch (error) {
      console.log(error);

      // alert(error.response.data.message);
    }
  };

  //delete model
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  function openDeleteModal(id) {
    setIsDeleteOpen(true);
    setid(id);
  }
  const deleteHandler = async () => {
    try {
      setisLoadingdelete(true);
      const response = await mfaApi.delete(
        `/nepaladmin/nepal/delete-university/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 201) {
        swal("Delete Successfully");
        setadded(true);
        await getEnquiry();
        setisLoadingdelete(false);
      } else {
        swal(response.data.message);
        setisLoadingdelete(false);
      }
    } catch (error) {
      swal(error.response.data.message);
      setisLoadingdelete(false);
    }
    setIsDeleteOpen(false);
  };

  let [isUpdateHomeOpen, setIsUpdateHomeOpen] = useState(false);
  function closeUpdateHomeModal() {
    setid();
    setResEnquiry({});
    setIsUpdateHomeOpen(false);
  }
  function openUpdateHomeModal(id) {
    setid(id);
    setIsUpdateHomeOpen(true);
  }
  let [isWorkassignOpen, setIsWorkassignOpen] = useState(false);
  function closeWorkassignOpen() {
    setIsWorkassignOpen(false);
  }
  function WorkAssignFunction(
    fullname,
    email,
    id,
    phone,
    servicetype,
    servicedate,
    address,
    description
  ) {
    setid(id);
    setIsWorkassignOpen(true);
    console.log(
      fullname,
      email,
      id,
      phone,
      servicetype,
      servicedate,
      address,
      description
    );
  }

  const [resdata, setResdata] = useState([]);

  const getServicesDetails = async () => {
    try {
      const response = await mfaApi.get(`/urbanadmin/getservicepublic`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setResdata(response.data.data);
        // setTotal(response.data);
      } else {
        swal(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };
  useEffect(() => {
    getServicesDetails();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [servicename, setServicename] = useState("");
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setServicename(selectedValue);
  };
  const [resenquiry, setResEnquiry] = useState({});
  const getEnquirybyId = async () => {
    try {
      const response = await mfaApi.get(
        `/nepaladmin/nepal/getbyiduniversity/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );

      if (response.status === 200) {
        setResEnquiry(response.data.data);
        // setTotal(response.data);
      } else {
        swal(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };
  useEffect(() => {
    // Check if id has a value before calling getEnquirybyId
    if (id) {
      getEnquirybyId();
    }

    // Cleanup function (if needed)
    return () => {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const gettreasurytabledatabysearch = (event) => {
    setSearchvalue(event.target.value);
    // Additional logic or function calls if needed
  };
  useEffect(() => {
    // Place your side effect code here
    // This code will run after the component renders
    getEnquiry();
    // You can perform cleanup by returning a function
    return () => {};
    // eslint-disable-next-line no-use-before-define, react-hooks/exhaustive-deps
  }, [searchvalue === ""]);
  function reloadPageWithDelay() {
    setTimeout(function () {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
      setNotifydata([]);
    }, 2000); // 2000 milliseconds (2 seconds)
  }
  const gettreasurytabledatabysearchapi = async () => {
    try {
      setIssearchLoading(true);
      const response = await mfaApi.get(
        `/nepaladmin/nepal/searchuniversity/${searchvalue}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 200) {
        setNotifydata(response.data.data);
        // setTotal(response.data);
        setIssearchLoading(false);
      } else {
        swal(response.data.message);
        setIssearchLoading(false);
        reloadPageWithDelay();
      }
    } catch (error) {
      swal(error.response.data.message);
      setIssearchLoading(false);
      reloadPageWithDelay();
    }
  };
  return (
    <Main>
      {" "}
      <div>
        <section className="mx-auto  w-full">
          <div className="bg-gray-100 rounded-md shadow-2xl shadow-green-600 py-1 mb-1">
            <p className="mx-auto flex justify-center uppercase text-black lg:text-2xl md:text-xl sm:text-lg font-sans ml-2 text-center">
              {" "}
              Enrolled Students
            </p>
            {issearchLoading && (
              <div className="flex items-center justify-end ">
                <ReactLoading
                  type="spinningBubbles"
                  color="#00000"
                  height={"2%"}
                  width={"2%"}
                />
                <p className="flex px-1 font-medium text-black">
                  please wait...
                </p>
              </div>
            )}
          </div>
          {/* <span className="flex justify-end text-white ">
            <input
              type="text"
              value={searchvalue}
              onChange={gettreasurytabledatabysearch}
              placeholder="Search....."
              className="text-left rounded-md text-sm text-black flex justify-end mr-2 w-1/4"
            />
            <div className="flex justify-end ">
              <button
                onClick={gettreasurytabledatabysearchapi}
                className="inline-flex justify-center py-1 px-2 border border-transparent shadow-sm text-lg font-bold rounded-md text-white bg-gray-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
                <p className="mx-1">Search</p>
              </button>
            </div>
          </span> */}
        </section>
      </div>
      {isLoading && (
        <div className="flex items-center justify-center my-2">
          <ReactLoading
            type="bubbles"
            color="#0143E2"
            height={"4%"}
            width={"4%"}
          />
          Loading...
        </div>
      )}
      {isLoadingdelete && (
        <div className="flex items-center justify-end my-10">
          <ReactLoading
            type="bubbles"
            color="#0143E2"
            height={"4%"}
            width={"4%"}
          />
          Deleting please wait....
        </div>
      )}
      {/* Show Skeleton if data has not yet been loaded */}
      {notifydata.length === 0 ? (
        <div className="my-2">
          <div>Loading...</div>
          <Skeleton count={5} height={30} />{" "}
          {/* Simple skeleton loading with 5 rows */}
        </div>
      ) : (
        <div className="flex flex-col h-[80vh]">
          <div className="overflow-auto border border-gray-200 rounded-lg">
            <table className="min-w-full table-fixed divide-y divide-gray-200">
              <thead className="bg-gray-300 sticky top-0 z-10">
                <tr>
                  {[
                    "S.no",
                    "View",
                    "Register Date",
                    "Username",
                    "Email",
                    "Phone",
                    "Purchased Course",
                    "Price",
                    "Payment ID",
                    "Delete",
                  ].map((heading, i) => (
                    <th
                      key={i}
                      className="px-3 py-3 text-left text-xs font-semibold text-gray-800 uppercase tracking-wider whitespace-nowrap"
                    >
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 text-sm text-gray-900">
                {notifydata
                  ?.slice()
                  .reverse()
                  .map((data, index) => (
                    <tr key={data.id}>
                      <td className="px-3 py-2 whitespace-nowrap">
                        {notifydata.length - index}
                      </td>

                      <td className="px-3 py-2">
                        <button
                          // onClick={() => openUpdateHomeModal(data.id)}
                          className="text-green-700 hover:text-green-900"
                          title="View"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                            />
                          </svg>
                        </button>
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.createdAt
                          ? new Date(data.createdAt).toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                          : "N/A"}
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.username || "N/A"}
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.email || "N/A"}
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap">
                        <a
                          href={`tel:${data.phone}`}
                          className="text-blue-600 hover:underline"
                        >
                          {data.phone || "N/A"}
                        </a>
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.examname || "N/A"}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.price || "N/A"}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap">
                        {data.paymentid || "N/A"}
                      </td>
                      <td className="px-3 py-2">
                        <button
                          // onClick={() => openDeleteModal(data.id)}
                          className="text-red-600 hover:text-red-800"
                          title="Delete"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673A2.25 2.25 0 0 1 15.916 21.75H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397M6.25 5.75a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <Transition appear show={isDeleteOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto "
          onClose={closeDeleteModal}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen  align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-md transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Delete
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-900">
                          Are you sure you want to delete ? All of your data
                          will be permanently removed. This action cannot be
                          undone.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={deleteHandler}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={closeDeleteModal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </Main>
  );
};

export default EnrolledStudents;
